import React from 'react'
import PropTypes from 'prop-types'

import ClippingEmptyIcon from 'components/ClippingEmptyIcon'

import styles from './styles'

const NotFoundMessage = (props) => {
  const classes = styles()
  const { message } = props

  return (
    <div className={classes.notFound}>
      <div className={classes.clippingEmpty}>
        <ClippingEmptyIcon />
      </div>
      <span>{message}</span>
    </div>
  )
}

NotFoundMessage.propTypes = {
  message: PropTypes.string,
}

NotFoundMessage.defaultProps = {
  message: 'Nenhum registro encontrado',
}

export default NotFoundMessage
